/**
 * 已知的路径冲突配置
 * 键：父路径，值：子路径数组
 * 当访问子路径时，父路径不应该激活
 */
const KNOWN_CONFLICTS: Record<string, string[]> = {
	"/activities": ["/activities/logs"],
};

/**
 * 检查路径是否激活
 * 使用精确匹配或路径前缀匹配，但排除子路径冲突
 * 
 * 特殊处理：如果存在独立的子路径菜单项（如 /activities/logs），
 * 则父路径（/activities）应该只精确匹配，避免同时激活
 */
export function isPathActive(currentPath: string, menuPath: string, allPaths: string[] = []): boolean {
	// 精确匹配
	if (currentPath === menuPath) {
		return true;
	}

	// 检查是否有已知的冲突路径
	const conflictPaths = KNOWN_CONFLICTS[menuPath] || [];
	const isOnConflictPath = conflictPaths.some(conflictPath => 
		currentPath === conflictPath || currentPath.startsWith(conflictPath + "/")
	);
	
	// 如果有冲突且当前在冲突路径上，父路径只精确匹配
	if (isOnConflictPath && conflictPaths.length > 0) {
		return currentPath === menuPath;
	}

	// 检查是否有其他菜单项是当前菜单项的子路径
	// 例如：如果存在 /activities/logs，则 /activities 应该使用精确匹配
	const hasSubPath = allPaths.some(
		(path) => path !== menuPath && path.startsWith(menuPath + "/")
	);

	if (hasSubPath) {
		// 如果有子路径菜单项，当前菜单项只精确匹配
		// 例如：/activities 不应该在访问 /activities/logs 时激活
		return currentPath === menuPath;
	}

	// 否则使用前缀匹配（支持子路由）
	return currentPath.startsWith(menuPath + "/") || currentPath === menuPath;
}

